export const pathConfig = {
  programs: { title: 'البرامج', isArrow: false },
  profile: { title: 'ملفي الشخصي', isArrow: true },
  users: { title: 'المستخدمون', isArrow: false },
  'home-slider': { title: 'شريط تمرير الصفحة الرئيسية', isArrow: false },
  'contact-messages': { title: 'رسائل التواصل', isArrow: false },
  'contact-settings': { title: 'إعدادات جهات التواصل', isArrow: false },
  'academic-calendar': { title: 'التقويم الأكاديمي', isArrow: false },
  attributes: { title: 'إعدادات', isArrow: false },
  dashboard: { title: 'لوحة القيادة', isArrow: false },
  applicants: { title: 'المتقدمين', isArrow: false },
  leads: { title: 'العملاء المحتملين', isArrow: false },
  newslettersubscription: {
    title: 'الاشتراك في النشرة الإخبارية',
    isArrow: false,
  },
  scholarships: { title: 'المنح الدراسية', isArrow: false },
  research: { title: 'البحث', isArrow: false },
  email: { title: 'نظام إدارة المتقدمين', isArrow: false },
  facilities: { title: 'المرافق', isArrow: false },
  quizzes: { title: 'الاختبارات القصيرة', isArrow: true },

  applications: { title: 'التطبيقات', isArrow: false },
  'echo-magazine': { title: 'مجلة صدى الأكاديمي', isArrow: false },
  'guide-lines': { title: 'الإرشادات', isArrow: false },
  'security-and-law': { title: 'الأمن والقانون', isArrow: false },
  'academic-research': { title: 'الأبحاث العلمية', isArrow: false },
  'new-email': { title: 'نموذج البريد الإلكتروني', isArrow: true },
  news: { title: 'الأخبار', isArrow: false },
  events: { title: 'الفعاليات', isArrow: false },
  newsletters: { title: 'المنشورات', isArrow: false },
  media: { title: 'معرض الصور', isArrow: false },
  'media-gallery': { title: 'معرض الصور ', isArrow: true },

  'add-news': { title: 'إضافة خبر', isArrow: true },
  'edit-news': { title: 'تعديل خبر', isArrow: true },
  'add-events': { title: 'إضافة فعالية', isArrow: true },
  'add-event-countdown': { title: 'إضافة عد تنازلي للفعالية', isArrow: true },
  'edit-event-countdown': {
    title: 'تعديل العد التنازلي للفعالية',
    isArrow: true,
  },
  'edit-event': { title: 'تعديل فعالية', isArrow: true },
  'add-home-slider': { title: 'شريحة الصفحة الرئيسية', isArrow: true },
  'edit-home-slider': { title: 'شريحة الصفحة الرئيسية', isArrow: true },
  'add-newsletters': { title: 'إضافة منشورة', isArrow: true },
  'edit-newsletters': { title: 'تعديل منشورة', isArrow: true },
  council: { title: 'المجلس', isArrow: false },
  faculty: { title: 'الكلية', isArrow: false },
  statistics: { title: 'الإحصائيات', isArrow: false },
  alumni: { title: 'قصص نجاح الخريجين', isArrow: false },
  'add-faculty': { title: 'إضافة كلية', isArrow: true },
  'edit-faculty': { title: 'تعديل كلية', isArrow: true },
  'create-council-calendar': { title: 'إنشاء تقويم للمجلس', isArrow: true },
  'add-council-member': { title: 'إضافة عضو للمجلس', isArrow: true },
  'edit-council-member': { title: 'تعديل عضو في المجلس', isArrow: true },
  'edit-council-news': { title: 'تعديل أخبار المجلس', isArrow: true },
  'add-council-news': { title: 'إضافة أخبار للمجلس', isArrow: true },
  'add-student-alumni': { title: 'إضافة خريج طالب', isArrow: true },
  'add-success-story': { title: 'إضافة قصة نجاح', isArrow: true },
  'edit-success-story': { title: 'تعديل قصة نجاح', isArrow: true },
  'add-ambassador': { title: 'إضافة سفير', isArrow: true },
  'edit-ambassador': { title: 'تعديل سفير', isArrow: true },
  'edit-student-alumni': { title: 'تعديل خريج طالب', isArrow: true },
  testimonials: { title: 'الشهادات والتوصيات', isArrow: false },
  'create-speech': { title: 'إنشاء خطاب', isArrow: true },
  'update-speech': { title: 'تحديث خطاب', isArrow: true },
  happinessMeter: { title: 'مقياس السعادة', isArrow: false },
  'research-opportunities': { title: 'فرص البحث', isArrow: false },
  'create-research-opportunity': { title: 'إنشاء فرصة بحث', isArrow: true },
  'edit-research-opportunity': { title: 'تعديل  فرصة بحث', isArrow: true },

  default: { title: 'محتوى الصفحة الرئيسية', isArrow: false },
};
